const selector = {
  products: ".collection-filters-products",
  product: ".filters-product",
  productTag: ".filters-product-tags",
  productRenderEmptyTag: "render-empty-tag",
  total: ".collection-filters-total",
  totalMb: ".collection-filters-total-mb",
  sidebarTitle: ".filters-sidebar-title",
  sidebarGroup: ".filters-sidebar__group",
  sidebarGroupClose: "is-close",
}
const PARAMS = {
  view: "view",
  sort_by: "sort_by",
  oldPage: "oP",
}

const FILTER = {
  collection: "collection_filter",
  tag: "tag_filter",
  range: "range_filter",
}

const SCOPE = {
  tag: "filter.p.tag",
}

document.addEventListener("alpine:init", function () {
  setupCollectionFiltersStore()
  Alpine.data("collectionFilters", collectionFiltersRender)
})

function collectionFiltersRender() {

  const sectionId = this.$el.closest(".shopify-section").getAttribute("id")

  return {
    sectionId: sectionId,
    loading: false,
    loaded: false,

    get filters() {
      return this.$store.filters.filters
    },
    get hasParams() {
      return this.$store.filters.hasParams
    },
    get sort_by() {
      return this.$store.filters.sort_by
    },
    get sort_by_label() {
      return this.$store.filters.sort_by_label
    },

    getType(item) {
      const type = item.type
      return type === FILTER.collection ? "radio" : "checkbox";
    },

    getDisabled(item) {
      switch (item.type) {
        case FILTER.collection:
          return !item.count
        case FILTER.range:
          return item.scope ? item.scope.length > 0 : true

        default:
          return false
      }
    },

    getActive(item) {
      switch (item.type) {
        case FILTER.collection:
          return item.value === this.$store.filters.handle;

        case FILTER.tag:
        case FILTER.range:
          return item.active;

        default:
          break;
      }
    },

    init() {
      window.addEventListener("resize", () => {
        this.checkFilterProductNeedRenderEmpty()
      })
      this.checkFilterProductNeedRenderEmpty()
    },

    openSort: false,
    isInitOutsideClick: false,
    onOpenSort() {
      this.openSort = true

      if (this.isInitOutsideClick) {
        return
      }

      this.isInitOutsideClick = true
      document.body.addEventListener('click', (e) => {
        if (!e.target.closest('.collection-filters-sort-by')) {
          this.openSort = false
        }
      })
    },

    onSortOutside() {
      this.openSort = false
    },

    onSortBy(sort, label) {
      this.$store.filters.sortBy(sort, label)
      this.fetchData()
      this.openSort = false
    },

    onPage(e) {
      e.preventDefault()
      if (e.target.tagName !== "A") {
        return
      }

      const href = e.target.getAttribute("href")
      const search = new URLSearchParams(href.replace(/^.*\?/, ''))
      const page = search.get("page")

      this.$store.filters.page(page)

      this.fetchData()
    },

    onToggleFilter(filter, item) {
      this.$store.filters.toggleFilter(filter, item)
      // 移动端不立即请求
      if (!this.isFiltersOpen) {
        this.$store.filters.page(1)
        this.fetchData()
      }
    },
    onClear() {
      this.closeFilter()
      if (!this.hasParams) {
        return
      }
      this.$store.filters.clear()
      this.fetchData()
    },
    onApply() {
      this.closeFilter()
      this.$store.filters.page(1)
      this.fetchData()
    },

    onSidebarToggle(e) {
      const group = e.target.closest(selector.sidebarGroup)
      if (!group) {
        return
      }

      group.classList.toggle(selector.sidebarGroupClose)
    },

    isFiltersOpen: false,
    filtersOpenAnimation: false,
    onOpenFilter() {
      this.$store.filters.resetCloneFilters()
      document.querySelector(".promotion_section").style.display = "none"
      this.openFilter()
    },
    onCloseFilter() {
      this.$store.filters.resetFilters()
      document.querySelector(".promotion_section").style.display = ""
      this.closeFilter()
    },
    openFilter() {
      this.isFiltersOpen = true
      setTimeout(() => {
        this.filtersOpenAnimation = true
      }, 100)
    },
    closeFilter() {
      this.filtersOpenAnimation = false
      setTimeout(() => {
        this.isFiltersOpen = false
      }, 500)
    },

    async fetchData() {

      const url = `${this.$store.filters.getURL()}&_ts=${Date.now()}`;

      this.loading = true
      this.loaded = false
      const titleEl = document.querySelector(selector.sidebarTitle)
      if (titleEl.getBoundingClientRect().top > 0 && titleEl.getBoundingClientRect().top < window.innerHeight) {
        // titleEl in view
      } else {
        document.querySelector(selector.sidebarTitle).scrollIntoView({
          behavior: 'smooth'
        });
      }

      // 同时只能请求一个，防止多次请求
      const controller = new AbortController();
      const signal = controller.signal;
      if (this.controller) {
        this.controller.abort();
      }
      this.controller = controller;
      try {
        const res = await fetch(url, {
          signal: signal,
          credentials: 'include'
        }).then(res => res.text())
        this.$store.filters.updateURL()

        const doc = new window.DOMParser().parseFromString(res, 'text/html');
        const contents = doc.querySelector(selector.products).innerHTML
        const total = doc.querySelector(selector.total).innerHTML
        const totalMb = doc.querySelector(selector.totalMb).innerHTML
        document.querySelector(selector.products).innerHTML = contents;
        document.querySelector(selector.total).innerHTML = total;
        document.querySelector(selector.totalMb).innerHTML = totalMb;
        this.checkFilterProductNeedRenderEmpty()
        this.loading = false
        this.loaded = true
      } catch (error) {
        console.error(error);
      }
    },

    checkFilterProductNeedRenderEmpty() {
      const products = Array.from(document.querySelectorAll(selector.product))
      // 根据视口宽度，按行分组, 生成新数组rows
      // 1920 3, 1024 2, 768 3, 375 2
      let group = 3
      if (window.innerWidth <= 1024) {
        group = 2
      }
      if (window.innerWidth <= 768) {
        group = 3
      }
      if (window.innerWidth <= 375) {
        group = 2
      }

      const rows = []
      for (let i = 0; i < products.length; i += group) {
        rows.push(products.slice(i, i + group))
      }

      // 判断每组productTag是否有内容
      // 如果没有内容，添加空元素
      rows.forEach((row) => {
        const tags = row.map((el) => el.querySelector(selector.productTag).innerHTML)
        if (tags.some((tag) => !tag)) {
          row.forEach((el) => {
            if (!el.querySelector(selector.productTag).innerHTML) {
              el.classList.add(selector.productRenderEmptyTag)
            }
          })
        }
      })


    }
  }
}

/**
 * [{key: 0, }, {key: 1}, {key: 2}, {key: 2}]
 * Map({
 *  0: [{key: 1}, {key: 1}],
 * 1: [{key: 2}, {key: 2}]
 * })
 */
function arrToMap(arr, key) {
  const map = new Map();
  arr.forEach((item) => {
    const k = item[key];
    if (map.has(k)) {
      map.get(k).list.push(item);
    } else {
      map.set(k, {
        type: item.type,
        name: k,
        list: [item],
      });
    }
  });
  return map;
}

function setupCollectionFiltersStore() {

  const searchParams = new URLSearchParams(location.search)
  const handle = location.pathname.replace("/collections/", "")
  const baseHandle = searchParams.has(PARAMS.oldPage) ? searchParams.get(PARAMS.oldPage) : location.pathname.replace("/collections/", "")

  Alpine.store("filters", {
    searchParams: searchParams,
    handle: handle,
    baseHandle: baseHandle,
    sort_by: searchParams.get(PARAMS.sort_by) || "best-selling",
    sort_by_label: "",
    filters: [],
    cloneFilters: [],

    hasParams: false,

    init() {
      const configFiltersJSON = document.querySelector("#configFiltersJSON")
      const renderFilters = arrToMap(window.renderFilters, 'category');
      const configFilters = arrToMap(window.configFilters || [], 'category');

      renderFilters.forEach((filters, key) => {
        switch (filters.type) {
          case FILTER.collection:
            this.renderStatusCollection(filters);
            break;
          case FILTER.tag:
            this.renderStatusTag(filters);
            break;
          case FILTER.range:
            this.renderStatusRange(filters, configFilters);
            break;

          default:
            break;
        }
      })

      this.filters = Array.from(renderFilters.values());
      this.resetHasParams();
    },

    //#region Public Methods
    resetHasParams() {
      if (this.searchParams.has(PARAMS.oldPage)) {
        this.hasParams = true;
        return
      }
      const hasParams = this.filters.some((filter) => {
        if (filter.type === FILTER.collection) {
          return false
        }

        return filter.list.some((item) => {
          if (item.active) {
            return true;
          }
        })
      })

      this.hasParams = hasParams;
    },
    getURL() {
      if (!this.searchParams.has(PARAMS.view)) {
        this.searchParams.set(PARAMS.view, "filyers-ups");
      }
      const pathname = `/collections/${this.handle}`
      return `${pathname}?${this.getSearchParamsStr()}`
    },
    getSearchParamsStr() {
      return this.searchParams.toString().replace(/%2C/g, ',')
    },
    clear() {
      const oldPage = this.searchParams.get(PARAMS.oldPage);
      const newSearch = new URLSearchParams({
        view: 'filyers-ups'
      });

      this.handle = oldPage ? oldPage : this.baseHandle;
      this.searchParams = newSearch
      this.clearFilter();
      this.hasParams = false;
    },
    clearFilter() {
      this.filters.forEach((filter) => {
        if (filter.type === FILTER.collection) {
          return
        }
        filter.list.forEach((item) => {
          item.active = false;
        })
      })
    },
    page(p) {
      if (p === "1") {
        this.searchParams.delete("page");
        return
      }

      this.searchParams.set("page", p);
    },

    sortBy(sort_by, label) {
      this.searchParams.set(PARAMS.sort_by, sort_by);
      this.sort_by = sort_by;
      this.sort_by_label = label;
    },

    toggleFilter(filter, item) {
      switch (filter.type) {
        case FILTER.collection:
          this.toggleFilterCollection(filter, item);
          break;

        case FILTER.tag:
          this.toggleFilterTag(filter, item);
          break;

        case FILTER.range:
          this.toggleFilterRange(filter, item);
          break;

        default:
          break;
      }
      this.resetHasParams();
    },
    //#endregion Public Methods

    resetCloneFilters() {
      this.cloneFilters = JSON.parse(JSON.stringify(this.filters));
    },

    resetFilters() {
      this.filters = JSON.parse(JSON.stringify(this.cloneFilters));
    },

    toggleFilterCollection(filter, item) {
      if (!this.searchParams.has(PARAMS.oldPage)) {
        this.setParams('set', PARAMS.oldPage, handle);
      }
      this.handle = item.value;
    },
    toggleFilterTag(filter, item) {
      if (item.active) {
        this.setParams('delete', SCOPE.tag, item.value);
      } else {
        this.setParams('append', SCOPE.tag, item.value);
      }
      item.active = !item.active;
    },
    toggleFilterRange(filter, item) {
      const filter_scope = item.filter_scope;
      if (item.active) {
        item.scope.forEach((scope) => {
          this.setParams('delete', filter_scope, scope.value);
        })
        item.active = false;
      } else {
        if (item.scope) {
          item.scope.forEach((scope) => {
            this.setParams('append', filter_scope, scope.value);
          })
          item.active = true;
        }
      }
    },

    renderStatusCollection(filters) {
      filters.list.forEach((item) => {
        item.active = this.handle === item.value;
      })
    },
    renderStatusTag(filters) {
      const params = new Set(this.searchParams.getAll(SCOPE.tag).join(',').split(','));
      filters.list.forEach((item) => {
        item.active = this.searchParams.has(SCOPE.tag) && params.has(item.value);
      })
    },
    renderStatusRange(filters, configFilters) {
      const list = filters.list;
      list.sort((a, b) => {
        return a.min_value - b.min_value;
      });

      list.forEach((item) => {
        const config = configFilters.get(item.filter_name)
        if (!config) {
          return
        }
        const scopeList = config.list;
        const scope = scopeList.filter((scope) => {
          if (!scope) {
            return
          }
          const num = Number(scope.value);

          if (item.min_value != undefined && item.max_value != undefined) {
            if (num >= item.min_value && num <= item.max_value) {
              return true;
            }
          } else if (item.min_value != undefined && item.max_value == undefined) {
            if (num >= item.min_value) {
              return true;
            }
          }
        });
        if (!scope || scope.length === 0) {
          return
        }
        if (!item.scope) {
          item.scope = [];
        }

        item.scope = item.scope.concat(scope);
      });

      list.forEach((item) => {
        const filter_scope = item.filter_scope;
        if (!item.scope) {
          return
        }
        const params = new Set(this.searchParams.getAll(filter_scope).join(',').split(','));
        item.active = this.searchParams.has(filter_scope) && item.scope.some((scope) => params.has(scope.value));
      })
    },

    setParams(type, key, value) {
      if (!this.searchParams.has(PARAMS.view)) {
        this.searchParams.set(PARAMS.view, "filyers-ups");
      }
      switch (type) {
        case 'set':
          this.searchParams.set(key, value);
          break;
        case 'append':
          if (this.searchParams.has(key)) {
            const list = this.searchParams.getAll(key);
            list.push(value);
            this.searchParams.set(key, list.join(','));
          } else {
            this.searchParams.set(key, value);
          }
          break;
        case 'delete':
          if (this.searchParams.has(key)) {
            const listStr = this.searchParams.getAll(key) || [""];
            const list = [...(new Set(listStr.join(',').split(',')))];
            list.splice(list.indexOf(value), 1);
            list.length ? this.searchParams.set(key, list.join(',')) : this.searchParams.delete(key);
          } else {
            this.searchParams.delete(key);
          }
          break;

        default:
          break;
      }

    },

    updateURL() {
      window.history.replaceState({}, '', this.getURL());
    }
  })
}
